var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrabajo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 59.428,
    viewBox: "0 0 64 59.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_681",
    "data-name": "Grupo 681",
    transform: "translate(-1164.977 -2382.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M316.857,877.143h-7.314l-7.109-32h9.851v16a2.293,2.293,0,0,0,2.286,2.286,2.286,2.286,0,0,1,0,4.572,2.286,2.286,0,1,0,0,4.571,6.846,6.846,0,0,0,2.286-13.3V845.143a4.585,4.585,0,0,0-4.571-4.572H301.428l-.617-2.788a2.233,2.233,0,0,0-2.24-1.737V836H280.286a9.14,9.14,0,0,0-9.143,9.143v32a9.143,9.143,0,1,0,0,18.286h45.714a9.143,9.143,0,1,0,0-18.286ZM287.143,852H299.28l2.034,9.143H287.143Zm-11.429-6.857a4.585,4.585,0,0,1,4.571-4.572h16.457l1.531,6.857H287.166A4.585,4.585,0,0,0,282.594,852v9.143a4.585,4.585,0,0,0,4.571,4.571h15.177l2.537,11.428H275.737v-32Zm41.143,45.714H271.143a4.571,4.571,0,1,1,0-9.143h45.714a4.571,4.571,0,1,1,0,9.143Z",
    transform: "translate(902.977 1546.012)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M286.29,861.581a2.29,2.29,0,1,0-2.29-2.29A2.291,2.291,0,0,0,286.29,861.581Z",
    transform: "translate(931.234 1572.988)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M280.29,861.581a2.29,2.29,0,1,0-2.29-2.29A2.291,2.291,0,0,0,280.29,861.581Z",
    transform: "translate(923.543 1572.988)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M274.29,861.581a2.29,2.29,0,1,0-2.29-2.29A2.291,2.291,0,0,0,274.29,861.581Z",
    transform: "translate(915.829 1572.988)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M268.29,861.581a2.29,2.29,0,1,0-2.29-2.29A2.291,2.291,0,0,0,268.29,861.581Z",
    transform: "translate(908.138 1572.988)",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrabajo);
export default __webpack_public_path__ + "static/media/trabajo.fad19ca5ea7cfdc8090db433cb5abd62.svg";
export { ForwardRef as ReactComponent };